<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleTabChange">
      <el-tab-pane label="门店工资" name="store">
        <tab-store :visible="activeName === 'store'"></tab-store>
      </el-tab-pane>
      <el-tab-pane label="授课绩效" name="achievements">
        <tab-achievements
          :visible="activeName === 'achievements'"
        ></tab-achievements>
      </el-tab-pane>
      <el-tab-pane label="工资明细" name="storeDetail">
        <tab-store-detail
          :visible="activeName === 'storeDetail'"
        ></tab-store-detail>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import tabAchievements from "./tabAchievements/index.vue";
import tabStore from "./tabStore/index.vue";
import eventBus from "@/utils/bus";
import { PageModule } from "@/store/module/page";
import tabStoreDetail from "./storeDetail/index.vue";
export default {
  components: {
    tabAchievements,
    tabStore,
    tabStoreDetail,
  },
  data() {
    return {
      activeName: "store",
    };
  },
  created() {
    eventBus.$on("quickly-create-salary-settlement", () => {
      this.activeName = "store";
    });
    const cache = PageModule.pageInfo.salary;
    if (cache.tab) {
      this.activeName = cache.tab;
    }
  },
  beforeDestroy() {
    eventBus.$off("quickly-create-salary-settlement");
  },
  methods: {
    handleTabChange(v) {
      PageModule.SET_PAGE_INFO({
        name: "salary",
        key: "tab",
        value: v.name,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
}
</style>
